import React from 'react';
import { Form, Input, Button,Row,Col } from 'antd';
import { useNavigate } from 'react-router-dom';
import '../../assets/css/CriarConta.css'; // Arquivo CSS para centralizar e estilizar
import Api from '../api/Api';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CriarConta = () => {
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      const costumerData = {
        Nome: values.nome,
        Email: values.email,
        Username: values.username,
        Senha: values.password,
      };
  
      const result = await Api.AddPartner(costumerData);
      if (result.success) {
        toast.success('Parceiro adicionado com sucesso!');
        setTimeout(() => {
          navigate('/');
        }, 2000); // Atraso de 2 segundos
      } else {
        toast.error('Erro ao adicionar Parceiro');
      }
    } catch (error) {
      toast.error('Erro ao adicionar cliente: ' + error.message);
    }
  };
  

  return (
    <div className="container">
         <ToastContainer /> {/* Coloque o ToastContainer aqui */}
      <div className="form-box">
        <h2 style={{ textAlign: 'center' }}>Criar Conta</h2>
        <Form name="create_account" onFinish={onFinish} style={{ marginTop: 20 }}>
          <Form.Item
            name="nome"
            rules={[{ required: true, message: 'Por favor, insira seu nome!' }]}
          >
            <Input placeholder="Nome Completo" />
          </Form.Item>

          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Por favor, insira seu e-mail!' },
              { type: 'email', message: 'Insira um e-mail válido!' },
            ]}
          >
            <Input placeholder="E-mail" />
          </Form.Item>

          <Row gutter={16}>
          <Col span={12}>
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Por favor, insira um nome de usuário!' }]}
          >
            <Input placeholder="Nome de usuário" />
          </Form.Item>
          </Col>

          <Col span={12}>
          <Form.Item
            name="password"
            rules={[{ min:4, required: true, message: 'Por favor, insira sua senha!' }]}
          >
            <Input.Password placeholder="Senha" />
          </Form.Item>
          </Col>
          </Row>
         





          <Row gutter={16}>

          <Col span={12}>
          <Form.Item>
            <Button
              style={{ width: '100%' }}
              onClick={() => navigate('/')}
            >
              Cancelar
            </Button>
          </Form.Item>
          </Col>
          <Col span={12}>

          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
              Criar Conta
            </Button>
          </Form.Item>



         
          </Col>

          </Row>



        </Form>
      </div>
    </div>
  );
};

export default CriarConta;
